import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUserDepartmentListCSV = () => {
  const url = `${apiConstants?.BASE_URL_1}/api/v1/ProductCategory/GetProductCategoryList`;
  const encodedUrl = encodeURIComponent(url);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.GET_USER_DEPARTMENT_LIST_CSV(encodedUrl)
  );
};

export default getUserDepartmentListCSV;
